// TODO: Add survey configs

export const surveyConfigs = [
  {
    componentReference: 'title',
    label: 'Survey',
    id: 'survey-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
    count: 8,
  },

  // 2 cards
  {
    componentReference: 'container',
    id: 'survey-cards-container',
    children: [
      // candidate nps card
      {
        containerType: 'survey',
        componentType: 'nps_score',
        componentReference: 'nps_score',
        id: 'survey_candidate_nps_card',
        selected: false,
        ui: {
          title: 'Candidate NPS',
          renderType: 'nps_score',
          id: 'survey_candidate_nps_card',
          score: 45,
          promoters: 67,
          passives: 25,
          detractors: 8,
          topLabel: 'Candidate NPS',
          bottomLabel: 'SURVEY',
        },
        api: {
          subject_type: 'ats_survey',
          metadata: {
            tileKey: 'survey_candidate_nps_card',
            componentType: 'nps_score',
            apiParam: 'card',
            id: 'survey_candidate_nps_card',
          },
        },
      },
      // hm nps card
      {
        containerType: 'survey',
        componentType: 'nps_score',
        componentReference: 'nps_score',
        id: 'survey_hm_nps_card',
        selected: false,
        ui: {
          title: 'HM NPS',
          renderType: 'nps_score',
          id: 'survey_hm_nps_card',
          score: -15,
          promoters: 33,
          passives: 17,
          detractors: 50,
          topLabel: 'HM NPS',
          bottomLabel: 'SURVEY',
        },
        api: {
          subject_type: 'ats_survey',
          metadata: {
            tileKey: 'survey_hm_nps_card',
            componentType: 'nps_score',
            apiParam: 'card',
            id: 'survey_hm_nps_card',
          },
        },
      },
    ],
  },

  //candidate nps over time chart
  {
    componentType: 'chart',
    componentReference: 'chart',
    id: 'survey_candidate_nps_chart',
    selected: false,
    cssProps: {
      width: '50%',
      display: 'block',
    },
    ui: {
      title: 'Candidate NPS over time',
      id: 'survey_candidate_nps_chart',
      chartData: {
        categories: ['2024-Q4', '2025-Q1'],
        series: [47.06, 48.0],
      },
      chartType: 'area',
    },
    api: {
      subject_type: 'ats_survey',
      metadata: {
        tileKey: 'survey_candidate_nps_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        id: 'survey_candidate_nps_chart',
      },
    },
  },

  // hm nps over time chart
  {
    componentType: 'chart',
    componentReference: 'chart',
    id: 'survey_hm_nps_chart',
    selected: false,
    cssProps: {
      width: '50%',
      display: 'block',
    },
    ui: {
      title: 'HM NPS over time',
      id: 'survey_hm_nps_chart',
      chartData: {
        categories: ['2024-Q4', '2025-Q1'],
        series: [58.33, 52.63],
      },
      chartType: 'area',
    },
    api: {
      subject_type: 'ats_survey',
      metadata: {
        tileKey: 'survey_hm_nps_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [],
        id: 'survey_hm_nps_chart',
      },
    },
  },

  // survey table
  {
    containerType: 'survey',
    componentType: 'table',
    componentReference: 'table',
    id: 'survey_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'NPS breakdown',
      id: 'survey_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          candidate_nps: 3,
          candidate_nps_total: 25,
          hm_nps: 1,
          hm_nps_total: 22,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          candidate_nps: 7,
          candidate_nps_total: 25,
          hm_nps: 2,
          hm_nps_total: 22,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          candidate_nps: 8,
          candidate_nps_total: 25,
          hm_nps: 8,
          hm_nps_total: 22,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          candidate_nps: 5,
          candidate_nps_total: 25,
          hm_nps: 4,
          hm_nps_total: 22,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          candidate_nps: 2,
          candidate_nps_total: 25,
          hm_nps: 6,
          hm_nps_total: 22,
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'ats_survey',
      metadata: {
        tileKey: 'survey_table',
        componentType: 'table',
        apiParam: 'chart_table',
        headerKeys: ['candidate_nps', 'hm_nps'],
        id: 'survey_table',
      },
    },
  },
];
